import { createSelector } from 'reselect'

const getData = (state, selector) => {
  const data = state.PupilsStore ? state.PupilsStore : state
  return !data ? null : selector(data)
}

const getPupilsFetchingStatus = state => getData(state, data => data.fetching)

const getPupils = state =>
  getData(state, data => (data.pupils ? data.pupils.entities.pupils : null))

const getPupil = (state, id) =>
  getData(state, data => (data.pupils ? data.pupils.entities.pupils[id] : null))

const getPupilsResultArray = state =>
  getData(state, data => (data.pupils ? data.pupils.result : null))

const getPupilsUpdatingStatuses = state => getData(state, data => data.updating)
const getPupilsDeletingStatuses = state => getData(state, data => data.deleting)
const getPupilsCreatingStatuses = state => getData(state, data => data.creating)
const getPupilsCreatingBatchStatus = state =>
  getData(
    state,
    data =>
      data.creatingBatch || {
        pending: false,
        requestError: false
      }
  )

const getPupilUpdatingStatus = (state, id) =>
  getPupilsUpdatingStatuses(state)[id] || {
    pending: false,
    requestError: false
  }

const getPupilDeletingStatus = (state, id) =>
  getPupilsDeletingStatuses(state)[id] || {
    pending: false,
    requestError: false
  }

const getPupilCreatingStatus = (state, id) =>
  getPupilsCreatingStatuses(state)[id] || {
    pending: false,
    requestError: false
  }

const getPupilAddingToGroupStatus = (state, id) =>
  getData(
    state,
    data => data.addingToGroup[id] || { pending: false, requestError: false }
  )

const getPupilRemovingFromGroupStatus = (state, id) =>
  getData(
    state,
    data =>
      data.removingFromGroup[id] || { pending: false, requestError: false }
  )

const getPupilIncrementingAgeGroupStatus = (state, id) =>
  getData(
    state,
    data => data.incrementingAge[id] || { pending: false, requestError: false }
  )

const getPupilsArray = createSelector(
  [getPupils, getPupilsResultArray],
  (pupils, result) => (result ? result.map(id => pupils[id]) : [])
)

export {
  getPupils,
  getPupilsArray,
  getPupilsFetchingStatus,
  getPupil,
  getPupilUpdatingStatus,
  getPupilDeletingStatus,
  getPupilCreatingStatus,
  getPupilAddingToGroupStatus,
  getPupilRemovingFromGroupStatus,
  getPupilIncrementingAgeGroupStatus,
  getPupilsCreatingBatchStatus
}
